@include host-component-properties;

:host {
  --paf-result-price-badge-font-size: 16;
  --paf-result-price-badge-line-height: 24;
  --paf-result-price-badge-padding-block: 2;
  --paf-result-price-badge-padding-inline: 16;
  --paf-result-price-badge-discount-gap: 4;
  --paf-result-price-badge-discount-background-color: var(--paf-global-post-brand-yellow);
  --paf-result-price-badge-discount-dimensions: 36;
  --paf-result-price-badge-discount-sign-padding-inline: 2;
  --paf-result-price-badge-border-weight: 1;
  --paf-result-price-badge-border-color: var(--paf-global-post-brand-secondary);
}

.badge {
  font-weight: var(--paf-global-font-weight-bold);
  font-size: px-to-rem(var(--paf-result-price-badge-font-size));
  line-height: px-to-rem(var(--paf-result-price-badge-line-height));
  padding-block: px-to-rem(var(--paf-result-price-badge-padding-block));
  padding-inline: px-to-rem(var(--paf-result-price-badge-padding-inline));
  border: px-to-rem(var(--paf-result-price-badge-border-weight)) solid var(--paf-result-price-badge-border-color);
  border-inline-end: none;
  border-block-start: none;
  display: none;
  position: relative;

  &.loading {
    border: none;
  }

  &.loading * {
    opacity: 0;
  }

  .loader {
    @include skeleton-loading;
  }

  @include mq($from: small) {
    display: inline-block;
  }

  &.is-discount {
    display: inline-flex;
    column-gap: px-to-rem(var(--paf-result-price-badge-discount-gap));
    background-color: var(--paf-result-price-badge-discount-background-color);
    border: none;

    @include mq($to: small) {
      background-color: transparent;
      padding: 0;
    }

    @include forced-colors {
      filter: invert(1);
    }
  }

  .discount {
    font-weight: inherit;

    @include mq($to: small) {
      width: px-to-rem(var(--paf-result-price-badge-discount-dimensions));
      height: px-to-rem(var(--paf-result-price-badge-discount-dimensions));
      padding-inline-end: px-to-rem(var(--paf-result-price-badge-discount-sign-padding-inline));
      text-align: right;
      background:
        linear-gradient(
          to bottom left,
          var(--paf-result-price-badge-discount-background-color) 50%,
          transparent 50%
        );
    }
  }

  .text {
    display: none;
    font-weight: inherit;

    @include mq($from: small) {
      display: block;
    }
  }
}
